<template>
    <div class="left_content" @scroll="scrollEnd" ref="scrollContainer">
        <div class="left_title">
            <div class="name">未回复消息</div>
        </div>
        <template v-if="historyList.length > 0">
            <div class="messageCard" @click="$emit('clickHistory', item)" style="position: relative;"
                v-for="(item, index) in historyList" :key="index" :item="item">
                <div style="position: absolute;right: 0;top: 0;" v-if="item.unAnswerCount > 0">
                    <el-badge :value="item.unAnswerCount" :max="99" class="item"></el-badge>
                </div>
                <div class="left">
                    <img class="photo"
                        :src="item.platformUserDetail?.thumbnailUrl ? item.platformUserDetail?.thumbnailUrl : require('@/assets/profile.png')"
                        alt="">
                    <!-- 会员皇冠图标 -->
                    <img v-if="item.platformUserDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png"
                        alt="VIP">
                    <div :class="['status', item.userDetail && item.userDetail.is_online ? '' : 'checkStatus']"></div>
                    <!-- <div class="time">{{ this.time(item) }}</div> -->
                </div>
                <div class="center">
                    <div class="center_top">
                        <div class="name">{{ item.platformUserDetail?.name }}</div>
                        <i class="el-icon-star-on status" style="color: red;" v-if="item.isFavorite == 1"></i>
                    </div>

                    <!-- 需要支持多种类型  -->
                    <div class="messageInfo" v-if="item.chatType == 'message'">{{ item.message }}</div>
                    <div class="messageInfo" v-if="item.chatType == 'smile'">[表情动画]</div>
                    <!-- <div class="messageInfo" v-if="item.chatType == 'email'"></div> -->
                    <div style="display: flex;"><img class="emailIcon" v-if="item.chatType == 'email'"
                            src="@/assets/emailIcon.png" alt=""> <span v-if="item.chatType == 'email'">邮件</span></div>
                </div>
                <div class="right">
                    <img class="right_photo"
                        :src="item.userDetail?.thumbnailUrl ? item.userDetail?.thumbnailUrl : require('@/assets/profile.png')"
                        alt="">
                    <!-- 会员皇冠图标 -->
                    <img v-if="item.userDetail?.isVip == 1" class="crown-icon-right" src="@/assets/icon/vip.png"
                        alt="VIP">
                    <div class="right_name">{{ item.userDetail?.name }}</div>
                </div>
            </div>
            <img v-if="loadingImgShow" ref="loadingImg" class="loadingImg rotate360" src="@/assets/loading.gif" alt="">
        </template>
        <!-- 未回复消息空状态 -->
        <div v-else class="empty-state">
            <div class="empty-content">
                <div class="empty-icon">
                    <img src="@/assets/qReply.png" alt="">
                </div>
                <div class="empty-title">暂无未回复消息</div>
                <div class="empty-subtitle">有待回复的消息会在这里显示</div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { getDialogueList } from '@/api/dialogue'
import { getOnlineStatus } from '@/api/talkytimes/user'
import { remove } from 'lodash'
export default {
    props: {
        item: {
            type: Object,
            default: () => { }
        }
    },
    components: {
    },
    computed: {
        time(item) {
            return dayjs(item.lastMsgTimestamp * 1).format('HH:mm')
        }
    },
    created() {
        this.getHistoryList()
    },
    watch: {
        historyList: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.updateOnlineStatus();
                }
            }
        }
    },
    data() {
        return {
            historyParams: {
                pageSize: 10,
                pageNum: 1,
                isUnAnswer: 1
            },
            historyList: [],
            historyTotal: 0,
            loadingImgShow: false,
            onlineQueryTimer: null // 在线状态查询定时器
        }
    },
    mounted() { },
    methods: {
        // 更新在线状态
        updateOnlineStatus() {
            if (this.onlineQueryTimer) {
                clearTimeout(this.onlineQueryTimer);
                this.onlineQueryTimer = null;
            }
            let ids = this.historyList.map(item => item.userId);
            getOnlineStatus({ ids }).then(res => {
                console.log('在线状态：', res)
                this.historyList.forEach(item => {
                    let is_online = res[item.userId] !== undefined ? res[item.userId] : false;
                    if (item.userDetail) {
                        item.userDetail.is_online = is_online;
                    } else {
                        item.userDetail = {
                            is_online
                        }
                    }
                })
            }).catch((error) => {
                // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，不显示错误提示
                if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
                    console.log('在线状态查询失败（连接超时），静默处理');
                    return;
                }
                // 其他错误也静默处理，在线状态查询失败不应该影响用户体验
                console.log('在线状态查询失败，静默处理:', error);
            })
            // 设置60秒后再次查询
            this.onlineQueryTimer = setTimeout(() => {
                this.updateOnlineStatus();
            }, 60000);
        },
        // 过滤掉被举报的用户
        filterReportedUsers(v) {
            this.historyList = this.historyList.filter(item => item.userId !== v)
        },
        changeMood(v) {
            this.historyList.forEach(item => {
                item.platformUserDetail.mood = v;
            })
        },
        async getHistoryList(v) {
            // 1️⃣ 开始请求前，统一打开 loading
            this.loadingImgShow = true

            if (v === 'new') {
                this.historyList = []
                this.historyParams = {
                    pageSize: 10,
                    pageNum: 1,
                    isUnAnswer: 1
                }
            } else {
                // 数据已全部加载完，直接退出并关闭 loading
                if (this.historyTotal > 0 && this.historyList.length >= this.historyTotal) {
                    this.loadingImgShow = false
                    return
                }
            }

            const res = await getDialogueList(this.historyParams);
            this.loadingImgShow = false
            if (res.code === 200) {
                this.historyList.push(...res.rows)
                this.historyTotal = res.total
                // 数据是否全部加载完
                if (this.historyParams.pageNum * this.historyParams.pageSize >= res.total) {
                } else {
                    // 未加载完，保持 loading，并继续判断是否需要自动加载下一页
                    this.$nextTick(() => this.checkAndLoadMore())
                }
            }
        },
        removeLi(v) {
            console.log(v)
            // 移出当前元素
            const index = this.historyList.findIndex(item => item.userId === v);
            if (index !== -1) {
                this.historyList.splice(index, 1);

                // 通知父组件未读数量已更新
                this.$emit('unreadCountChanged', this.historyList.length);
            }
        },
        // 检查是否需要加载更多数据来填满滚动区域
        checkAndLoadMore() {
            const container = this.$refs.scrollContainer;
            if (!container) return;

            // 如果容器高度大于等于内容高度，说明没有滚动条，需要继续加载
            if (container.clientHeight >= container.scrollHeight) {
                // 避免无限加载，检查是否还有更多数据
                if (this.historyTotal > this.historyList.length) {
                    this.historyParams.pageNum++;
                    this.getHistoryList();
                }
            }
        },
        // 是否滚动到当前元素底部
        scrollEnd() {
            // 防抖处理
            if (this.scrollDebounce) {
                clearTimeout(this.scrollDebounce);
            }

            this.scrollDebounce = setTimeout(() => {
                const container = this.$refs.scrollContainer;
                // 添加50px的缓冲区域
                const threshold = 50;
                const isBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + threshold;

                if (isBottom) {
                    this.historyParams.pageNum++
                    this.getHistoryList()
                }
            }, 100);
        },

    },
    beforeDestroy() {
        // 清理定时器
        if (this.onlineQueryTimer) {
            clearTimeout(this.onlineQueryTimer);
            this.onlineQueryTimer = null;
        }
    }
}
</script>

<style scoped lang='scss'>
.messageCard {
    display: flex;
    align-items: center;
    height: 92px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background-color: #F7F9FA;
    border-radius: 8px;
    margin-bottom: 4px;
    cursor: pointer;

    .left {
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .photo {
            width: 36px;
            height: 36px;
            // margin-bottom: 8px;
            border-radius: 8px;
        }

        .crown-icon {
            position: absolute;
            top: -4px;
            right: 6px;
            width: 16px;
            height: 16px;
            z-index: 10;
        }

        .status {
            position: absolute;
            bottom: 0;
            right: 10px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #0CD85D;
        }

        .checkStatus {
            background-color: #e5e5e5;
        }

        .time {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
        }
    }

    .center {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-right: 13px;
        min-width: 60px;

        .center_top {
            display: flex;
            align-items: center;
            margin-bottom: 6px;

            .name {
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-right: 6px;
                white-space: nowrap;
            }

            .status {
                width: 14px;
                height: 14px;
            }
        }

        .messageInfo {
            width: 100%;
            // height: 44px;
            overflow: hidden;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
        }
    }

    .right {
        // width: 133px;
        height: 52px;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        padding: 8px;
        background-color: #fff;
        border-radius: 8px;
        position: relative;

        .right_photo {
            width: 36px;
            height: 36px;
            margin-right: 8px;
            border-radius: 8px;
        }

        .crown-icon-right {
            position: absolute;
            top: 4px;
            left: 28px;
            width: 16px;
            height: 16px;
            z-index: 10;
        }

        .right_name {
            flex: 1;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 90px;
        }
    }
}

.emailIcon {
    width: 22px;
    height: 18px;
    margin-right: 6px;
}

.loadingImg {
    width: 30px;
    height: 30px;
    margin: 0 auto;
}

.left_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .name {
        font-weight: 500;
        font-size: 20px;
        color: #333333;
    }

    .dropdown {
        .img {
            width: 38px;
            height: 26px;
            cursor: pointer;
        }
    }
}

.left_content {
    height: 100%;
    overflow-x: hidden;
}

.message_list {
    flex: 1;
    overflow-y: auto; // 显示滚动条
    overflow-x: hidden;

    &::-webkit-scrollbar {
        display: none;
    }
}

// 空状态样式
.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;

    .empty-content {
        text-align: center;
        color: #909399;

        .empty-icon {
            display: flex;
            justify-content: center;
            margin-bottom: 16px;

            img {
                width: 56px;
                height: 56px;
                opacity: 0.8;
                filter: grayscale(20%) brightness(105%);
            }
        }

        .empty-title {
            font-size: 16px;
            font-weight: 500;
            color: #606266;
            margin-bottom: 8px;
        }

        .empty-subtitle {
            font-size: 12px;
            color: #909399;
            line-height: 1.4;
        }
    }
}

/* 连接状态样式 */
.connecting {
    opacity: 0.6;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        pointer-events: none;
        z-index: 1;
    }
}

.connection-indicator {
    position: absolute;
    top: 4px;
    left: 4px;
    z-index: 2;

    .spinner {
        width: 12px;
        height: 12px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #2499FF;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>